import { exportHack } from '../../utils/exportHack';
import { ProductCell, } from './ProductCell';
import { ProductCellPrimary, } from './ProductCellPrimary';
import { ProductCellQuaternary, } from './ProductCellQuaternary';
import { ProductCellSecondary, } from './ProductCellSecondary';
import { ProductCellTertiary, } from './ProductCellTertiary';
const ExportHackProductCell = (exportHack({
    component: ProductCell,
    constants: {
        Primary: ProductCellPrimary,
        Quaternary: ProductCellQuaternary,
        Secondary: ProductCellSecondary,
        Tertiary: ProductCellTertiary,
    },
}));
export { ExportHackProductCell as ProductCell, ProductCellPrimary, ProductCellQuaternary, ProductCellSecondary, ProductCellTertiary, };
